function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import deepExtend from 'deep-extend';
const {
  take,
  race,
  delay,
  all
} = LIFE_CYCLE_EVENT_BUS.effects;
const CONTEXT_KEY = Symbol.for('@thd-olt-component-react/thd-analytics/state');
const globalSymbols = Object.getOwnPropertySymbols(global);
const hasState = globalSymbols.indexOf(CONTEXT_KEY) > -1;
if (!hasState) {
  global[CONTEXT_KEY] = {};
}
const state = global[CONTEXT_KEY];
state.store = {};
export const getState = () => {
  return state.store;
};
const parseSelectorState = (selector, localState) => {
  const parts = selector.split('.');
  let current = _objectSpread({}, localState);
  for (let i = 0; i < parts.length; i++) {
    //eslint-disable-line
    const key = parts[i];
    if (typeof current[key] !== 'undefined') {
      current = current[key];
      if (i === parts.length - 1) return current;
    } else {
      break;
    }
  }
  return undefined;
};
export function selectSingleState(selector) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function* () {
    const localState = getState();
    const result = parseSelectorState(selector, localState);
    if (typeof result !== 'undefined') return result;
    while (true) {
      const {
        timeout
      } = yield race({
        event: take('thd-analytics.state-change'),
        timeout: delay(opts.timeout || 10000)
      });
      if (timeout) return null;
      const res = parseSelectorState(selector, getState());
      if (res) return res;
    }
  }();
}

// 'dataSources.products.12345'
export function selectState(selector) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function* () {
    if (typeof selector === 'string') {
      return yield selectSingleState(selector, opts);
    }
    return yield all(selector.map(sel => selectSingleState(sel, opts)));
  }();
}
export const resetState = () => {
  state.store = {};
  return state.store;
};
export const setState = newState => {
  deepExtend(state.store, newState);
  LIFE_CYCLE_EVENT_BUS.trigger('thd-analytics.state-change', state.store);
  return state.store;
};
//# sourceMappingURL=analytics-state.js.map